/**
 * Utilitários para cartões Cricket (checklist JSON, prévia de HTML).
 */

/**
 * @param {unknown} raw
 * @returns {{ id: string, text: string, done: boolean }[]}
 */
export function parseCricketChecklist(raw) {
  if (raw == null || raw === '') return [];
  try {
    const v = typeof raw === 'string' ? JSON.parse(raw) : raw;
    if (!Array.isArray(v)) return [];
    return v
      .filter((x) => x != null && typeof x === 'object')
      .slice(0, 500)
      .map((x, i) => ({
        id: String(x.id || `c${i}`).slice(0, 64),
        text: String(x.text ?? ''),
        done: !!x.done,
      }));
  } catch {
    return [];
  }
}

/**
 * @param {string} html
 * @param {number} max
 */
export function htmlToPlainPreview(html, max = 160) {
  if (!html || typeof html !== 'string') return '';
  const t = html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  if (t.length <= max) return t;
  return `${t.slice(0, max)}…`;
}

/** @param {unknown} mysqlOrIso */
export function dueValueToDatetimeLocal(mysqlOrIso) {
  if (!mysqlOrIso) return '';
  const s = typeof mysqlOrIso === 'string' ? mysqlOrIso.replace(' ', 'T') : String(mysqlOrIso);
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** @param {string} localVal datetime-local value */
export function datetimeLocalToIsoOrNull(localVal) {
  if (!localVal || typeof localVal !== 'string') return null;
  const d = new Date(localVal);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}

/**
 * Cor salva no banco → valor seguro para CSS (evita injeção em style).
 * @param {unknown} raw
 * @returns {string | null}
 */
export function cardCoverHex(raw) {
  if (raw == null || raw === '') return null;
  const s = String(raw).trim();
  if (/^#[0-9A-Fa-f]{6}$/i.test(s)) return s.toLowerCase();
  if (/^#[0-9A-Fa-f]{3}$/i.test(s)) {
    return (`#${s[1]}${s[1]}${s[2]}${s[2]}${s[3]}${s[3]}`).toLowerCase();
  }
  return null;
}

export const CRICKET_CARD_COVER_PRESETS = [
  '#84cc16',
  '#22c55e',
  '#14b8a6',
  '#3b82f6',
  '#8b5cf6',
  '#ec4899',
  '#f97316',
  '#eab308',
  '#64748b',
];
